import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Vendors extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			OWNER_NAME: ''
		};
		
		var vendorListInit = this.copyTable(vendorList);
		vendorListInit.query.search = this.constructSearch(search);

		this.state = {
			vendorList: vendorListInit,
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onSubmitSearch(event) {
		var newVendorList = this.copyTable(vendorList);
		newVendorList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			vendorList: newVendorList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.OWNER_NAME)) search.Children.push({ Attribute: 'OWNER_NAME', Operator: 'like', StringValue: '%' + data.OWNER_NAME + '%' });

		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addVendor() {
		this.props.navigate('/HeLAD/Vendors/new');
	}
	
	editVendor(vendorId) {
		this.props.setVendorEditable(true);
		this.props.navigate('/HeLAD/Vendors/' + vendorId);		
	}

	viewVendor(vendorId) {
		this.props.setVendorEditable(false);
		this.props.navigate('/HeLAD/Vendors/' + vendorId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Vendors',
			columns: exportColumns,
			entity: 'DEMURRAGE.DEM_OWNERS',
			search: this.constructSearch(this.state.search)
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Vendors</span>
						<ChemEdit parent={this} columns={vendorSearch} data={this.state.search} renderKey={this.state.renderKey} 
						  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} {...this.props} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='HeLAD_Vendors' table={this.state.vendorList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='190px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const vendorSearch = [
	{ Header: 'Name', accessor: 'OWNER_NAME', row: 0, col: 0 },
];

const vendorList = {
	query: { entity: 'DEMURRAGE.DEM_OWNERS', search: null },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addVendor()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editVendor(props.row.values.OWNER_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'OWNER_ID', width: 50,
			Cell: props => <HashLink onClick={() => props.parent.viewVendor(props.value)}>{props.value}</HashLink> },
		{ Header: 'Description', accessor: 'OWNER_NAME', width: 250 },
		{ Header: 'Comments', accessor: 'COMMENTS', width: 200 },
		{ Header: 'Contact Person', accessor: 'CONTACT_PERSON', width: 200 },
		{ Header: 'Contact Phone', accessor: 'CONTACT_PHONE', width: 125 },
		{ Header: 'Deactivated', accessor: 'DELETE_FLAG', width: 90 },
		{ Header: 'Modified By', accessor: 'MODIF_BY', width: 125 },
		{ Header: 'Date Modified', accessor: 'MODIF_DATE', width: 200 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'OWNER_ID', width: 10 },
	{ Header: 'Description', accessor: 'OWNER_NAME', width: 50 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 40 },
	{ Header: 'Contact Person', accessor: 'CONTACT_PERSON', width: 40 },
	{ Header: 'Contact Phone', accessor: 'CONTACT_PHONE', width: 25 },
	{ Header: 'Deactivated', accessor: 'DELETE_FLAG', width: 18 },
	{ Header: 'Modified By', accessor: 'MODIF_BY', width: 25 },
	{ Header: 'Date Modified', accessor: 'MODIF_DATE', width: 40 }
];

export default withRouter(Vendors);
